var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"icon-action"},[_c('div',{staticClass:"icon-container",on:{"click":_vm.download}},[_c('download-icon',{attrs:{"size":24}})],1),_c('div',{staticClass:"label text-sm"},[_vm._v("Download")])])}
var staticRenderFns = []

export { render, staticRenderFns }